import { useParams } from 'react-router-dom';
import { PageContainer } from '../components/styles/containers.styled';

const EmptyTokenDetails = () => {
    return <PageContainer>

    </PageContainer>;
};

export default EmptyTokenDetails;